/* Snowryx · eventos propios para Microsoft Clarity.
   Clarity solo registra lo que el visitante ha consentido; este script no crea cookies. */
(function () {
  'use strict';
  var fired = {};

  function track(name, once, tags) {
    if (once) {
      if (fired[name]) return;
      fired[name] = true;
    }
    try {
      if (typeof window.clarity !== 'function') return;
      window.clarity('event', name);
      if (tags) for (var k in tags) window.clarity('set', k, String(tags[k]));
    } catch (e) {}
  }

  // Secciones vistas (una vez por página)
  function sectionName(el) {
    var id = (el.id || '').replace('shopify-section-', '');
    var i = id.lastIndexOf('__');
    return i > -1 ? id.slice(i + 2) : id;
  }
  if ('IntersectionObserver' in window) {
    var secObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var n = sectionName(en.target);
        if (n) track('vio_' + n, true);
        secObs.unobserve(en.target);
      });
    }, { threshold: 0.35 });
    document.querySelectorAll('.shopify-section').forEach(function (s) {
      if (s.id && sectionName(s) && !/header|footer|announcement/i.test(s.id)) secObs.observe(s);
    });

    // Vídeos de la ficha vistos (≥50 % visible)
    var vids = document.querySelectorAll('.sx-videos video');
    if (vids.length) {
      var vObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var idx = Array.prototype.indexOf.call(vids, en.target) + 1;
          track('video_visto_' + idx, true);
          vObs.unobserve(en.target);
        });
      }, { threshold: 0.5 });
      vids.forEach(function (v) { vObs.observe(v); });
    }
  }

  // Profundidad de scroll (la ventana o el contenedor del tema que scrollee)
  var marks = [25, 50, 75, 100];
  document.addEventListener('scroll', function (e) {
    var el = e.target === document ? document.scrollingElement : e.target;
    if (!el || el.nodeType !== 1) return;
    var h = el.scrollHeight - el.clientHeight;
    if (h < window.innerHeight) return;
    var p = (el.scrollTop / h) * 100;
    marks.forEach(function (m) { if (p >= m - 1) track('scroll_' + m, true); });
  }, { passive: true, capture: true });

  // Pack elegido
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('input[name="sx_pack"]')) {
      var names = { '1': 'pack_1_par', '2': 'pack_duo', '3': 'pack_trio' };
      track(names[t.value] || 'pack_otro', false, { pack: names[t.value] || t.value });
    } else if (t.matches('variant-picker input[type="radio"], variant-picker select, .variant-picker input[type="radio"]')) {
      track('color_elegido', false, { color: t.value });
    }
  });

  // Preguntas frecuentes abiertas (el evento toggle no burbujea: captura)
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.tagName === 'DETAILS' && d.open && d.closest('.sx-faq')) {
      var q = d.querySelector('summary');
      track('faq_abierta', false, { faq: q ? q.textContent.trim().slice(0, 60) : '' });
    }
  }, true);

  // Clics clave
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    if (t.closest('button[name="add"], add-to-cart-component button[type="submit"], .add-to-cart-button')) track('anadir_al_carrito');
    else if (t.closest('[name="checkout"], a[href="/checkout"]')) track('ir_al_pago');
    else if (t.closest('.sx-videos video')) track('video_clic');
    else if (t.closest('a[href*="/pages/contact"]')) track('clic_contacto', true);
    else if (t.closest('a[href*="/pages/seguimiento"], a[href*="tracking"]')) track('clic_seguimiento', true);
  });
})();
